module.exports = __webpack_public_path__ + "img/Penarol.c13b5a63.png";